import { Obj } from "scrivito"
import {
  ProductAttributes,
  ProductObj
} from "scrivito/Objs/Product/ProductObjClass"
import {
  ProductBaseVariantAttributes,
  ProductBaseVariantObj
} from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"

import { getProductType } from "entities/products/lib/getProductType"

import { ProductSearchResult } from "../types/GlobalSearch"

export function transformProductObjToProductSearchResult(
  obj: Obj<ProductAttributes | ProductBaseVariantAttributes>
): Omit<ProductSearchResult, "matchInfo"> {
  return {
    id: obj.id(),
    title: obj.get("title") as string,
    productType: getProductType(obj.get("variantKey") || ""),
    variantKey: obj.get("variantKey"),
    obj: obj as ProductObj | ProductBaseVariantObj
  }
}
